/**
 * Breadcrumb configuration — maps route paths to i18n label keys.
 * Keys reuse the same translation keys from adminNavConfig to avoid duplication.
 */
export const BREADCRUMB_MAP: Record<string, string> = {
  // Admin root
  '/admin': 'adminNav.admin',
  // Oversight
  '/admin/activity': 'adminNav.activityLog',
  // Payroll
  '/admin/approvals': 'adminNav.reportApprovals',
  '/admin/payroll': 'adminNav.payrollManagement',
  // Employment
  '/admin/employment-roles': 'adminNav.employmentRoles',
  '/admin/hospital-assignments': 'adminNav.hospitalAssignments',
  '/admin/allowance-types': 'adminNav.allowanceTypes',
  '/admin/hospitals': 'adminNav.hospitals',
  '/admin/treatments': 'adminNav.treatments',
  '/admin/helmets': 'adminNav.helmets',
  '/admin/report-types': 'adminNav.reportTypes',
  '/admin/report-builder': 'adminNav.reportBuilder',
  // Resources
  '/admin/users': 'adminNav.usersManagement',
  '/admin/roles': 'adminNav.roles',
  // System
  '/admin/rss-feeds': 'adminNav.rssFeeds',
  '/admin/relations': 'adminNav.relations',
  '/admin/region-config': 'adminNav.regionConfig',
  '/admin/currencies': 'adminNav.currencies',
  '/admin/approval-config': 'adminNav.approvalConfig',
  '/admin/settings': 'adminNav.systemSettings',
  '/admin/features': 'adminNav.featureFlags',
  // User-facing routes
  '/reports': 'nav.reports',
  '/feed': 'nav.feed',
  '/dashboard': 'nav.dashboard',
  '/hospitals': 'nav.hospitals',
  '/settings': 'nav.settings',
};
